export default __webpack_public_path__ + "resources/icons/d410-cf97.png";